import { useAccount, useReadContract } from "wagmi";
import { formatUnits } from "viem";

import { toFixedWithoutRounding } from "@constants/common";

import useDappConfig from "./useDappConfig";

const useStableVaultXTokenAllowance = () => {
  const { address: walletAddress } = useAccount();

  const { stableVaultConfig } = useDappConfig();

  const { xToken } = stableVaultConfig;

  const { data } = useReadContract({
    ...xToken,
    functionName: "allowance",
    args: [walletAddress, stableVaultConfig.interactionPool.address],
    query: {
      enabled: !!walletAddress,
      refetchInterval: 5_000,
      initialData: 0n,
    },
  });

  return {
    xTokenAllowance: +toFixedWithoutRounding(
      data ? formatUnits(data as bigint, xToken.decimals) : "0",
      8
    ),
  };
};

export default useStableVaultXTokenAllowance;
